import {IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IImportTask extends IBaseEntity {
    id?: number;
    integrationType?: string;
    s3Bucket?: string;
    s3Key?: string;
    taskStatus?: string;
    createdOn?: string;
    lastProcessedOn?: string;
    sourceFileUrls?: string;
    executionFailed?: boolean;
    executionError?: string;
    executionRetryNumber?: number;
    createdByUserId?: number;
    createdByUserLogin?: string;
}

export class ImportTask implements IImportTask {
    id?: number;
    integrationType?: string;
    s3Bucket?: string;
    s3Key?: string;
    taskStatus?: string;
    createdOn?: string;
    lastProcessedOn?: string;
    sourceFileUrls?: string;
    executionFailed?: boolean;
    executionError?: string;
    executionRetryNumber?: number;
    createdByUserId?: number;
    createdByUserLogin?: string;

    constructor(obj?: any) {
        if (obj) {
            this.id = obj.id;
            this.integrationType = obj.integrationType;
            this.s3Bucket = obj.s3Bucket;
            this.s3Key = obj.s3Key;
            this.taskStatus = obj.taskStatus;
            this.createdOn = obj.createdOn;
            this.lastProcessedOn = obj.lastProcessedOn;
            this.sourceFileUrls = obj.sourceFileUrls;
            this.executionFailed = obj.executionFailed;
            this.executionError = obj.executionError;
            this.executionRetryNumber = obj.executionRetryNumber;
            this.createdByUserId = obj.createdByUserId;
            this.createdByUserLogin = obj.createdByUserLogin;
        }
    }

    discriminator?: any;
    toFormObject() {
        throw new Error('Method not implemented.');
    }
    clone(): IBaseEntity {
        return new ImportTask(this);
    }
}
